/* eslint-disable */

const Granite = {
  I18n: {
    'de-DE': {
      'AEM experience fragments': 'AEM-Experience Fragments',
      'Administer Target overview ': 'Übersicht über die Verwaltung von Target ',
      'Adobe Target Activities Guide ': 'Handbuch für Adobe Target Activity ',
      'Adobe Target Activities Overview ': 'Übersicht über Adobe Target Activity ',
      'Audiences overview ': 'Übersicht über Audiences ',
      'Blogs': 'Blogs',
      'Creating Audiences in Adobe Target ': 'Erstellen von Audiences in Adobe Target ',
      'Creating and using Profile Attributes ': 'Erstellen und Verwenden von Profilattributen ',
      'Customer Care': 'Kundendienst',
      'Defining success metrics for activities': 'Festlegen von Erfolgsmetriken für Aktivitäten',
      'Delivering Dynamic, Personalized Experiences with Adobe Target’s New User-Based Recommendations Algorithm ': 'Bereitstellen von dynamische, personalisierten Erlebnissen mithilfe des neuen anwenderbasierten Recommendations-Algorithmus in Adobe Target ',
      'Developer Connection': 'Developer Connection',
      'Help Home': 'Hilfe-Startseite',
      'Implement Target with Adobe Experience Platform Launch ': 'Implementieren von Target mit Adobe Experience Platform Launch ',
      'Offers overview ': 'Übersicht über Angebote ',
      'Organize your sites for easy management and separated reporting ': 'Organisieren Ihrer Websites für eine einfache Verwaltung und getrenntes Reporting ',
      'Passing dynamic data into offers': 'Weitergeben von dynamischen Daten an Angebote',
      'Personalizing with Adobe Target Recommendations ': 'Personalisieren mit Adobe Target Recommendations ',
      'Recommendations overview ': 'Übersicht über Recommendations ',
      'Setting your account preferences ': 'Einstellen Ihrer Kontovoreinstellungen ',
      'System Status': 'Systemstatus',
      'Troubleshooting activities': 'Fehlerbehebung bei Aktivitäten',
      'Understanding How Adobe Target at.js 2.0 Works ': 'Verstehen der Funktionsweise von Adobe Target at.js 2.0 ',
      'Understanding Target reports': 'Grundlegendes zu Target-Berichten',
      'Use Profile Comparison to build Audiences in Adobe Target ': 'Verwenden des Profilvergleichs zum Erstellen von Audiences in Adobe Target ',
      'Using Audiences in Adobe Target ': 'Verwenden von Audiences in Adobe Target ',
      'Using Experience Fragment Offers within Adobe Target ': 'Verwenden von Experience Fragment-Angeboten innerhalb von Adobe Target ',
      'Using the Visual Experience Composer in Adobe Target': 'Verwenden von Visual Experience Composer in Adobe Target',
      'Videos': 'Videos',
      'What\'s New With Adobe Target': 'Neue Funktionen von Adobe Target',
      'Working with content in the library': 'Arbeiten mit Inhalt in der Bibliothek'
    },
    'en-US': {
      'AEM experience fragments': 'AEM experience fragments',
      'Administer Target overview ': 'Administer Target overview ',
      'Adobe Target Activities Guide ': 'Adobe Target Activities Guide ',
      'Adobe Target Activities Overview ': 'Adobe Target Activities Overview ',
      'Audiences overview ': 'Audiences overview ',
      'Blogs': 'Blogs',
      'Creating Audiences in Adobe Target ': 'Creating Audiences in Adobe Target ',
      'Creating and using Profile Attributes ': 'Creating and using Profile Attributes ',
      'Customer Care': 'Customer Care',
      'Defining success metrics for activities': 'Defining success metrics for activities',
      'Delivering Dynamic, Personalized Experiences with Adobe Target’s New User-Based Recommendations Algorithm ': 'Delivering Dynamic, Personalized Experiences with Adobe Target’s New User-Based Recommendations Algorithm ',
      'Developer Connection': 'Developer Connection',
      'Help Home': 'Help Home',
      'Implement Target with Adobe Experience Platform Launch ': 'Implement Target with Adobe Experience Platform Launch ',
      'Offers overview ': 'Offers overview ',
      'Organize your sites for easy management and separated reporting ': 'Organize your sites for easy management and separated reporting ',
      'Passing dynamic data into offers': 'Passing dynamic data into offers',
      'Personalizing with Adobe Target Recommendations ': 'Personalizing with Adobe Target Recommendations ',
      'Recommendations overview ': 'Recommendations overview ',
      'Setting your account preferences ': 'Setting your account preferences ',
      'System Status': 'System Status',
      'Troubleshooting activities': 'Troubleshooting activities',
      'Understanding How Adobe Target at.js 2.0 Works ': 'Understanding How Adobe Target at.js 2.0 Works ',
      'Understanding Target reports': 'Understanding Target reports',
      'Use Profile Comparison to build Audiences in Adobe Target ': 'Use Profile Comparison to build Audiences in Adobe Target ',
      'Using Audiences in Adobe Target ': 'Using Audiences in Adobe Target ',
      'Using Experience Fragment Offers within Adobe Target ': 'Using Experience Fragment Offers within Adobe Target ',
      'Using the Visual Experience Composer in Adobe Target': 'Using the Visual Experience Composer in Adobe Target',
      'Videos': 'Videos',
      'What\'s New With Adobe Target': 'What\'s New With Adobe Target',
      'Working with content in the library': 'Working with content in the library',
    },
    'es-ES': {
      'AEM experience fragments': 'Fragmentos de experiencias AEM',
      'Administer Target overview ': 'Introducción a la administración de Target ',
      'Adobe Target Activities Guide ': 'Guía de actividades de Adobe Target ',
      'Adobe Target Activities Overview ': 'Introducción a las actividades de Adobe Target ',
      'Audiences overview ': 'Introducción a audiencias ',
      'Blogs': 'Blogs',
      'Creating Audiences in Adobe Target ': 'Crear audiencias en Adobe Target ',
      'Creating and using Profile Attributes ': 'Crear y usar atributos de perfil ',
      'Customer Care': 'Servicio atención al cliente',
      'Defining success metrics for activities': 'Definición de métricas de éxito para las actividades',
      'Delivering Dynamic, Personalized Experiences with Adobe Target’s New User-Based Recommendations Algorithm ': 'Entrega de experiencias personalizadas y dinámicas con el nuevo algoritmo de usuario basado en Adobe Target Recommendations. ',
      'Developer Connection': 'Developer Connection',
      'Help Home': 'Página inicial de Ayuda',
      'Implement Target with Adobe Experience Platform Launch ': 'Implementar Target con Adobe Experience Platform Launch ',
      'Offers overview ': 'Introducción a las ofertas ',
      'Organize your sites for easy management and separated reporting ': 'Organizar los sitios para gestionar sistemas de forma sencilla y crear informes individuales ',
      'Passing dynamic data into offers': 'Transferencia de datos dinámicos a ofertas',
      'Personalizing with Adobe Target Recommendations ': 'Personalizar con Adobe Target Recommendations ',
      'Recommendations overview ': 'Introducción a Recommendations ',
      'Setting your account preferences ': 'Configurar las preferencias de la cuenta. ',
      'System Status': 'Estado del sistema',
      'Troubleshooting activities': 'Actividades de solución de problemas',
      'Understanding How Adobe Target at.js 2.0 Works ': 'Funcionamiento de Adobe Target at.js 2.0 ',
      'Understanding Target reports': 'Información detallada sobre los informes de Target',
      'Use Profile Comparison to build Audiences in Adobe Target ': 'Usar la comparación de perfiles para generar audiencias en Adobe Target ',
      'Using Audiences in Adobe Target ': 'Usar audiencias en Adobe Target ',
      'Using Experience Fragment Offers within Adobe Target ': 'Usar las ofertas de Experience Fragment en Adobe Target. ',
      'Using the Visual Experience Composer in Adobe Target': 'Uso del Compositor de experiencias visuales (VEC) en Adobe Target',
      'Videos': 'Vídeos',
      'What\'s New With Adobe Target': 'Novedades de Adobe Target',
      'Working with content in the library': 'Uso de contenidos en la biblioteca'
    },
    'fr-FR': {
      'AEM experience fragments': 'Fragments d’expérience AEM',
      'Administer Target overview ': 'Présentation de l’administration dans Target ',
      'Adobe Target Activities Guide ': 'Guide des activités d’Adobe Target ',
      'Adobe Target Activities Overview ': 'Présentation des activités dans Adobe Target ',
      'Audiences overview ': 'Présentation des audiences ',
      'Blogs': 'Blogs',
      'Creating Audiences in Adobe Target ': 'Création d’audiences dans Adobe Target ',
      'Creating and using Profile Attributes ': 'Création et utilisation des attributs de profil ',
      'Customer Care': 'Assistance clientèle',
      'Defining success metrics for activities': 'Définition des mesures de succès pour les activités',
      'Delivering Dynamic, Personalized Experiences with Adobe Target’s New User-Based Recommendations Algorithm ': 'Offrir des expériences dynamiques et personnalisées grâce au nouvel algorithme de recommandations basées sur les utilisateurs d’Adobe Target ',
      'Developer Connection': 'Developer Connection',
      'Help Home': 'Accueil de l’aide',
      'Implement Target with Adobe Experience Platform Launch ': 'Mise en œuvre de Target avec Adobe Experience Platform Launch ',
      'Offers overview ': 'Présentation des offres ',
      'Organize your sites for easy management and separated reporting ': 'Organisation de vos sites pour une gestion simplifiée et un reporting distinct ',
      'Passing dynamic data into offers': 'Transformation de données dynamiques en offres',
      'Personalizing with Adobe Target Recommendations ': 'Personnalisation à l’aide des recommandations d’Adobe Target ',
      'Recommendations overview ': 'Présentation des recommandations ',
      'Setting your account preferences ': 'Configuration des préférences de votre compte ',
      'System Status': 'Statut du système',
      'Troubleshooting activities': 'Résolution des problèmes liés aux activités',
      'Understanding How Adobe Target at.js 2.0 Works ': 'Comprendre le fonctionnement d’Adobe Target at.js 2.0 ',
      'Understanding Target reports': 'Comprendre les rapports de Target',
      'Use Profile Comparison to build Audiences in Adobe Target ': 'Utilisation de la comparaison des profils pour créer des audiences dans Adobe Target ',
      'Using Audiences in Adobe Target ': 'Utilisation des audiences dans Adobe Target ',
      'Using Experience Fragment Offers within Adobe Target ': 'Utilisation des offres de fragments d’expérience dans Adobe Target ',
      'Using the Visual Experience Composer in Adobe Target': 'Utilisation du compositeur d’expérience visuelle dans Adobe Target',
      'Videos': 'Vidéos',
      'What\'s New With Adobe Target': 'Nouveautés d’Adobe Target',
      'Working with content in the library': 'Travail avec du contenu dans la bibliothèque'
    },
    'it-IT': {
      'AEM experience fragments': 'Frammenti di esperienza AEM',
      'Administer Target overview ': 'Gestire la panoramica di Target ',
      'Adobe Target Activities Guide ': 'Guida alle attività di Adobe Target ',
      'Adobe Target Activities Overview ': 'Panoramica delle attività di Adobe Target ',
      'Audiences overview ': 'Panoramica di Audiences ',
      'Blogs': 'Blog',
      'Creating Audiences in Adobe Target ': 'Generare un pubblico in Adobe Target ',
      'Creating and using Profile Attributes ': 'Creazione e utilizzo degli attributi del Profilo ',
      'Customer Care': 'Assistenza clienti',
      'Defining success metrics for activities': 'Definizione delle metriche di successo per le attività',
      'Delivering Dynamic, Personalized Experiences with Adobe Target’s New User-Based Recommendations Algorithm ': 'Fornire esperienze dinamiche e personalizzate con il nuovo algoritmo di Recommendations di Adobe Target basato sull’utente ',
      'Help Home': 'Home Aiuto',
      'Implement Target with Adobe Experience Platform Launch ': 'Implementare Target in Adobe Experience Platform Launch ',
      'Offers overview ': 'Panoramica delle Offerte ',
      'Organize your sites for easy management and separated reporting ': 'Organizza i tuoi siti per assicurare una gestione più semplice con reportistica separata ',
      'Passing dynamic data into offers': 'Passaggio dei dati dinamici nelle offerte',
      'Personalizing with Adobe Target Recommendations ': 'Personalizzazione con le Recommendations di Adobe Target ',
      'Recommendations overview ': 'Panoramica di Recommendations ',
      'Setting your account preferences ': 'Impostazione delle preferenze dell\'account ',
      'System Status': 'Stato del sistema',
      'Troubleshooting activities': 'Attività di risoluzione dei problemi',
      'Understanding How Adobe Target at.js 2.0 Works ': 'Guida al funzionamento di Adobe Target at.js 2.0 ',
      'Understanding Target reports': 'Comprensione dei rapporti di Target',
      'Using Audiences in Adobe Target ': 'Uso del pubblico in Adobe Target ',
      'Using Experience Fragment Offers within Adobe Target ': 'Utilizzo delle Offerte di Frammenti di esperienza all\'interno di Adobe Target ',
      'Using the Visual Experience Composer in Adobe Target': 'Uso di Visual Experience Composer di Adobe Target',
      'Videos': 'Video',
      'What\'s New With Adobe Target': 'Novità di Adobe Target',
      'Working with content in the library': 'Utilizzo del contenuto della libreria'
    },
    'ja-JP': {
      'AEM experience fragments': 'AEM エクスペリエンスフラグメント',
      'Administer Target overview ': 'Target の管理の概要',
      'Adobe Target Activities Guide ': 'Adobe Target アクティビティガイド',
      'Adobe Target Activities Overview ': 'Adobe Target アクティビティの概要',
      'Audiences overview ': 'Audiences の概要',
      'Blogs': 'ブログ',
      'Creating Audiences in Adobe Target ': 'Adobe Target での Audiences の作成',
      'Creating and using Profile Attributes ': 'プロファイルアトリビュートの作成と使用',
      'Customer Care': 'カスタマーケア',
      'Defining success metrics for activities': 'アクティビティの成功指標を定義する',
      'Developer Connection': 'Developer Connection',
      'Help Home': 'ヘルプホーム',
      'Implement Target with Adobe Experience Platform Launch ': 'Adobe Experience Platform Launch で Target を実装する',
      'Offers overview ': 'オファーの概要',
      'Organize your sites for easy management and separated reporting ': 'サイトを整理することで管理が容易になり、個別でのレポートを実現する',
      'Passing dynamic data into offers': 'オファーに動的なデータを渡す',
      'Personalizing with Adobe Target Recommendations ': 'Adobe Target Recommendations を使用してパーソナライズする。',
      'Recommendations overview ': 'Recommendations の概要',
      'Setting your account preferences ': 'アカウント環境設定',
      'System Status': 'システムステータス',
      'Troubleshooting activities': 'トラブルシューティングアクティビティ',
      'Understanding How Adobe Target at.js 2.0 Works ': 'js 2.0 での Adobe Target の仕組みについて',
      'Understanding Target reports': 'Target レポートについて',
      'Use Profile Comparison to build Audiences in Adobe Target ': 'プロファイル比較を使用して Adobe Target で Audiences を構築する',
      'Using Audiences in Adobe Target ': 'Adobe Target での Audiences の使用',
      'Using Experience Fragment Offers within Adobe Target ': 'Adobe Target 内で Experience Fragment Offers を使用する',
      'Using the Visual Experience Composer in Adobe Target': 'Adobe Target で Visual Experience Composer を使用する',
      'Videos': 'ビデオ',
      'What\'s New With Adobe Target': 'Adobe Target の新機能',
      'Working with content in the library': 'ライブラリのコンテンツの操作'
    },
    'ko-KR': {
      'AEM experience fragments': 'AEM 경험 조각',
      'Administer Target overview ': 'Administer Target 개요 ',
      'Adobe Target Activities Guide ': 'Adobe Target 활동 안내서 ',
      'Adobe Target Activities Overview ': 'Adobe Target 활동 개요 ',
      'Audiences overview ': '대상 개요 ',
      'Blogs': '블로그',
      'Creating Audiences in Adobe Target ': 'Adobe Target에서 대상 만들기 ',
      'Creating and using Profile Attributes ': '프로필 속성 생성 및 사용 ',
      'Customer Care': '고객 지원',
      'Defining success metrics for activities': '활동에 대한 성공 지표 정의',
      'Delivering Dynamic, Personalized Experiences with Adobe Target’s New User-Based Recommendations Algorithm ': 'Adobe Target의 새로운 사용자 기반 권장 사항 알고리즘으로 역동적이고 개인화된 경험 제공 ',
      'Developer Connection': 'Developer Connection',
      'Help Home': '도움말 홈',
      'Implement Target with Adobe Experience Platform Launch ': 'Adobe Experience Platform Launch로 타겟 구현 ',
      'Offers overview ': '오퍼 개요 ',
      'Organize your sites for easy management and separated reporting ': '손쉬운 관리 및 개별 보고를 위한 사이트 구성 ',
      'Passing dynamic data into offers': '동적 데이터를 오퍼로 전달',
      'Personalizing with Adobe Target Recommendations ': 'Adobe Target 권장 사항으로 개인화하기 ',
      'Recommendations overview ': '권장 사항 개요 ',
      'Setting your account preferences ': '계정 환경 설정을 설정 ',
      'System Status': '시스템 상태',
      'Troubleshooting activities': '활동 문제 해결',
      'Understanding How Adobe Target at.js 2.0 Works ': 'Adobe Target at.js 2.0 작동 방식 이해하기 ',
      'Understanding Target reports': 'Target 보고서 이해',
      'Use Profile Comparison to build Audiences in Adobe Target ': '프로필 비교를 사용하여 Adobe Target에서 대상 구축 ',
      'Using Audiences in Adobe Target ': 'Adobe Target에서 대상 사용 ',
      'Using Experience Fragment Offers within Adobe Target ': 'Adobe Target 내에서 경험 조각 오퍼 사용 ',
      'Using the Visual Experience Composer in Adobe Target': 'Adobe Target에서 시각적 경험 작성기 사용',
      'Videos': '비디오',
      'What\'s New With Adobe Target': 'Adobe Target의 새로운 기능',
      'Working with content in the library': '라이브러리의 컨텐츠로 작업',
    },
    'pt-BR': {
      'AEM experience fragments': 'Fragmentos de experiência do AEM',
      'Administer Target overview ': 'Resumo do Administer Target ',
      'Adobe Target Activities Guide ': 'Guia de atividades do Adobe Target ',
      'Adobe Target Activities Overview ': 'Resumo das atividades do Adobe Target ',
      'Audiences overview ': 'Resumo do Audiences ',
      'Blogs': 'Blogs',
      'Creating Audiences in Adobe Target ': 'Criação de Audiences no Adobe Target ',
      'Creating and using Profile Attributes ': 'Criação e uso de atributos de perfil ',
      'Customer Care': 'Atendimento ao cliente',
      'Defining success metrics for activities': 'Definição de métricas de sucesso para atividades',
      'Delivering Dynamic, Personalized Experiences with Adobe Target’s New User-Based Recommendations Algorithm ': 'Oferecimento de experiências dinâmicas e personalizadas com o novo algoritmo de recomendações baseadas no usuário do Adobe Target ',
      'Help Home': 'Página inicial da Ajuda',
      'Implement Target with Adobe Experience Platform Launch ': 'Implemente o Target com o Adobe Experience Platform Launch ',
      'Offers overview ': 'Resumo de Offers ',
      'Organize your sites for easy management and separated reporting ': 'Organize seus sites para facilitar o gerenciamento e gerar relatórios separados ',
      'Passing dynamic data into offers': 'Passagem de dados dinâmicos para ofertas',
      'Personalizing with Adobe Target Recommendations ': 'Personalização com o Adobe Target Recommendations ',
      'Recommendations overview ': 'Resumo do Recommendations ',
      'Setting your account preferences ': 'Definição das preferências de conta ',
      'System Status': 'Status do sistema',
      'Troubleshooting activities': 'Atividades de solução de problemas',
      'Understanding How Adobe Target at.js 2.0 Works ': 'Noções básicas sobre o funcionamento do Adobe Target at.js 2.0 ',
      'Understanding Target reports': 'Entendimento dos relatórios do Target',
      'Use Profile Comparison to build Audiences in Adobe Target ': 'Use a Comparação de perfis para criar públicos-alvo no Adobe Target ',
      'Using Audiences in Adobe Target ': 'Uso de Audiences no Adobe Target ',
      'Using Experience Fragment Offers within Adobe Target ': 'Uso de Experience Fragment Offers no Adobe Target ',
      'Using the Visual Experience Composer in Adobe Target': 'Uso do Visual Experience Composer no Adobe Target',
      'Videos': 'Vídeos',
      'What\'s New With Adobe Target': 'Novidades do Adobe Target',
      'Working with content in the library': 'Trabalho com conteúdo na biblioteca'
    },
    'zh-CN': {
      'AEM experience fragments': 'AEM 体验片段',
      'Administer Target overview ': '管理 Target 概述',
      'Adobe Target Activities Guide ': 'Adobe Target 活动指南',
      'Adobe Target Activities Overview ': 'Adobe Target 活动概述',
      'Blogs': '博客',
      'Creating Audiences in Adobe Target ': '在 Adobe Target 中创建受众',
      'Creating and using Profile Attributes ': '创建并使用配置文件属性',
      'Customer Care': '客户关怀',
      'Defining success metrics for activities': '为活动定义成功量度',
      'Delivering Dynamic, Personalized Experiences with Adobe Target’s New User-Based Recommendations Algorithm ': '运用 Adobe Target 新增的基于用户的推荐算法，提供动态、个性化的体验',
      'Developer Connection': 'Developer Connection',
      'Help Home': '帮助主页',
      'Implement Target with Adobe Experience Platform Launch ': '在 Adobe Experience Platform Launch 中实施 Target',
      'Offers overview ': '选件概述',
      'Organize your sites for easy management and separated reporting ': '组织您的站点以便轻松管理并分别报告',
      'Passing dynamic data into offers': '将动态数据传递到选件',
      'Personalizing with Adobe Target Recommendations ': '运用 Adobe Target 的推荐实现个性化处理',
      'Recommendations overview ': '推荐概述',
      'Setting your account preferences ': '设置您的帐户首选项',
      'System Status': '系统状态',
      'Troubleshooting activities': '活动疑难解答',
      'Understanding How Adobe Target at.js 2.0 Works ': '了解 Adobe Target at.js 2.0 的工作原理',
      'Understanding Target reports': '了解 Target 报表',
      'Use Profile Comparison to build Audiences in Adobe Target ': '在 Adobe Target 中运用“配置文件比较”以构建受众',
      'Using Audiences in Adobe Target ': '在 Adobe Target 中使用受众',
      'Using Experience Fragment Offers within Adobe Target ': '在 Adobe Target 中使用“体验片段选件”',
      'Using the Visual Experience Composer in Adobe Target': '在 Adobe Target 中使用可视化体验编辑器',
      'Videos': '视频',
      'What\'s New With Adobe Target': 'Adobe Target 的新增功能',
      'Working with content in the library': '使用库中的内容'
    },
    'zh-TW': {
      'AEM experience fragments': 'AEM 體驗片段',
      'Administer Target overview ': '管理 Target 概覽 ',
      'Adobe Target Activities Guide ': 'Adobe Target 活動指南 ',
      'Adobe Target Activities Overview ': 'Adobe Target 活動概覽 ',
      'Audiences overview ': '對象概覽 ',
      'Blogs': '部落格',
      'Creating Audiences in Adobe Target ': '在 Adobe Target 中建立對象 ',
      'Creating and using Profile Attributes ': '建立和使用設定檔屬性 ',
      'Customer Care': '客戶服務',
      'Defining success metrics for activities': '定義活動的成功量度',
      'Delivering Dynamic, Personalized Experiences with Adobe Target’s New User-Based Recommendations Algorithm ': '使用 Adobe Target 以使用者為基礎的全新建議演算法，提供動態、個人化的體驗 ',
      'Developer Connection': 'Developer Connection',
      'Help Home': '說明首頁',
      'Implement Target with Adobe Experience Platform Launch ': '使用 Adobe Experience Platform Launch 實作 Target ',
      'Offers overview ': '選件概覽 ',
      'Organize your sites for easy management and separated reporting ': '管理您的站台，以進行簡易管理和分隔的報表 ',
      'Passing dynamic data into offers': '將動態資料傳送至選件',
      'Personalizing with Adobe Target Recommendations ': '使用 Adobe Target 建議進行個人化 ',
      'Recommendations overview ': '建議概覽 ',
      'Setting your account preferences ': '設定您的帳戶偏好設定 ',
      'System Status': '系統狀態',
      'Troubleshooting activities': '疑難排解活動',
      'Understanding How Adobe Target at.js 2.0 Works ': '了解 Adobe Target at.js 2.0 的運作方式 ',
      'Understanding Target reports': '瞭解 Target 報表',
      'Use Profile Comparison to build Audiences in Adobe Target ': '在 Adobe Target 中使用設定檔比較來建置對象 ',
      'Using Audiences in Adobe Target ': '在 Adobe Target 中使用對象 ',
      'Using Experience Fragment Offers within Adobe Target ': '使用 Adobe Target 內的體驗片段選件 ',
      'Using the Visual Experience Composer in Adobe Target': '在 Adobe Target 中使用可視化體驗撰寫器',
      'Videos': '視訊',
      'What\'s New With Adobe Target': 'Adobe Target 最新資訊',
      'Working with content in the library': '使用資料庫內容'
    },
  }
};

const helpConfigOverride = (locale) => ({
  featured: [
    {
      description: Granite.I18n[locale]['Audiences overview '],
      href: 'https://docs.adobe.com/content/help/en/target/using/audiences/target.html ',
      label: Granite.I18n[locale]['Audiences overview '],
      path: '/:orgId?/target/audiences'
    },
    {
      description: Granite.I18n[locale]['Creating Audiences in Adobe Target '],
      href: 'https://docs.adobe.com/content/help/en/target/using/audiences/create-audiences/audiences.html ',
      label: Granite.I18n[locale]['Creating Audiences in Adobe Target '],
      path: '/:orgId?/target/audiences'
    },
    {
      description: Granite.I18n[locale]['Using Audiences in Adobe Target '],
      href: 'https://video.tv.adobe.com/v/17398/?quality=12&autoplay=true&learn=on ',
      label: Granite.I18n[locale]['Using Audiences in Adobe Target '],
      path: '/:orgId?/target/audiences'
    },
    {
      description: Granite.I18n[locale]['Creating and using Profile Attributes '],
      href: 'https://docs.adobe.com/content/help/en/target/using/audiences/visitor-profiles/profile-parameters.html ',
      label: Granite.I18n[locale]['Creating and using Profile Attributes '],
      path: '/:orgId?/target/audiences'
    },
    {
      description: Granite.I18n[locale]['Adobe Target Activities Overview '],
      href: 'https://docs.adobe.com/content/help/en/target/using/activities/activities.html ',
      label: Granite.I18n[locale]['Adobe Target Activities Overview '],
      path: '/:orgId?/target/activities'
    },
    {
      description: Granite.I18n[locale]['Adobe Target Activities Guide '],
      href: 'https://docs.adobe.com/content/help/en/target/using/activities/target-activities-guide.html ',
      label: Granite.I18n[locale]['Adobe Target Activities Guide '],
      path: '/:orgId?/target/activities'
    },
    {
      description: Granite.I18n[locale]['Using the Visual Experience Composer in Adobe Target'],
      href: 'https://docs.adobe.com/content/help/en/target-learn/tutorials/experiences/use-the-visual-experience-composer.html ',
      label: Granite.I18n[locale]['Using the Visual Experience Composer in Adobe Target'],
      path: '/:orgId?/target/activities'
    },
    {
      description: Granite.I18n[locale]['Defining success metrics for activities'],
      href: 'https://docs.adobe.com/content/help/en/target/using/activities/success-metrics/success-metrics.html ',
      label: Granite.I18n[locale]['Defining success metrics for activities'],
      path: '/:orgId?/target/activities'
    },
    {
      description: Granite.I18n[locale]['Understanding Target reports'],
      href: 'https://docs.adobe.com/content/help/en/target/using/reports/reports.html ',
      label: Granite.I18n[locale]['Understanding Target reports'],
      path: '/:orgId?/target/activities'
    },
    {
      description: Granite.I18n[locale]['Troubleshooting activities'],
      href: 'https://docs.adobe.com/content/help/en/target/using/activities/troubleshoot-activities/troubleshooting-activities.html ',
      label: Granite.I18n[locale]['Troubleshooting activities'],
      path: '/:orgId?/target/activities'
    },
    {
      description: Granite.I18n[locale]['Offers overview '],
      href: 'https://docs.adobe.com/content/help/en/target/using/experiences/offers/manage-content.html ',
      label: Granite.I18n[locale]['Offers overview '],
      path: '/:orgId?/target/offers'
    },
    {
      description: Granite.I18n[locale]['Administer Target overview '],
      href: 'https://docs.adobe.com/content/help/en/target/using/administer/administrating-target.html ',
      label: Granite.I18n[locale]['Administer Target overview '],
      path: '/:orgId?/target/setup'
    },
    {
      description: Granite.I18n[locale]['Setting your account preferences '],
      href: 'https://docs.adobe.com/content/help/en/target-learn/tutorials/administration/set-up-account-preferences.html ',
      label: Granite.I18n[locale]['Setting your account preferences '],
      path: '/:orgId?/target/setup'
    },
    {
      description: Granite.I18n[locale]['Organize your sites for easy management and separated reporting '],
      href: 'https://docs.adobe.com/content/help/en/target/using/administer/hosts.html ',
      label: Granite.I18n[locale]['Organize your sites for easy management and separated reporting '],
      path: '/:orgId?/target/setup'
    },
    {
      description: Granite.I18n[locale]['Recommendations overview '],
      href: 'https://docs.adobe.com/content/help/en/target/using/recommendations/recommendations.html ',
      label: Granite.I18n[locale]['Recommendations overview '],
      path: '/:orgId?/target/products'
    },
    {
      description: Granite.I18n[locale]['Delivering Dynamic, Personalized Experiences with Adobe Target’s New User-Based Recommendations Algorithm '],
      href: 'https://theblog.adobe.com/delivering-dynamic-personalized-experiences-with-adobe-targets-new-user-based-recommendations-algorithm/ ',
      label: Granite.I18n[locale]['Delivering Dynamic, Personalized Experiences with Adobe Target’s New User-Based Recommendations Algorithm '],
      path: '/:orgId?/target/products'
    },
    {
      description: Granite.I18n[locale]['Personalizing with Adobe Target Recommendations '],
      href: 'https://video.tv.adobe.com/v/29322/?quality=12&autoplay=true&learn=on ',
      label: Granite.I18n[locale]['Personalizing with Adobe Target Recommendations '],
      path: '/:orgId?/target/products'
    },
    {
      description: Granite.I18n[locale]['Understanding How Adobe Target at.js 2.0 Works '],
      href: 'https://video.tv.adobe.com/v/26250/?quality=9&autoplay=true&learn=on ',
      label: Granite.I18n[locale]['Understanding How Adobe Target at.js 2.0 Works '],
      path: '/:orgId?/target/setup'
    },
    {
      description: Granite.I18n[locale]['Implement Target with Adobe Experience Platform Launch '],
      href: 'https://docs.adobe.com/content/help/en/core-services-learn/implementing-in-websites-with-launch/implement-solutions/target.html ',
      label: Granite.I18n[locale]['Implement Target with Adobe Experience Platform Launch '],
      path: '/:orgId?/target/setup'
    },
    {
      description: Granite.I18n[locale]['Use Profile Comparison to build Audiences in Adobe Target '],
      href: 'https://docs.adobe.com/content/help/en/target-learn/tutorials/audiences/use-profile-comparison-to-build-audiences.html ',
      label: Granite.I18n[locale]['Use Profile Comparison to build Audiences in Adobe Target '],
      path: '/:orgId?/target/audiences'
    },
    {
      description: Granite.I18n[locale]['Using Experience Fragment Offers within Adobe Target '],
      href: 'https://docs.adobe.com/content/help/en/experience-manager-learn/sites/personalization/experience-fragment-target-offer-feature-video-use.html ',
      label: Granite.I18n[locale]['Using Experience Fragment Offers within Adobe Target '],
      path: '/:orgId?/target/activities'
    },
    {
      description: Granite.I18n[locale]['Working with content in the library'],
      href: 'https://docs.adobe.com/content/help/en/target/using/experiences/offers/assets-working.html',
      label: Granite.I18n[locale]['Working with content in the library'],
      path: '/:orgId?/target/offers'
    },
    {
      description: Granite.I18n[locale]['Passing dynamic data into offers'],
      href: 'https://docs.adobe.com/content/help/en/target/using/experiences/offers/passing-profile-attributes-to-the-html-offer.html',
      label: Granite.I18n[locale]['Passing dynamic data into offers'],
      path: '/:orgId?/target/offers'
    },
    {
      description: Granite.I18n[locale]['AEM experience fragments'],
      href: 'https://docs.adobe.com/content/help/en/target/using/experiences/offers/aem-experience-fragments.html',
      label: Granite.I18n[locale]['AEM experience fragments'],
      path: '/:orgId?/target/offers'
    }
  ],
  recommendations: {
  enabled: false,
    terms: [
      {
        path: '/:orgId?/target/(.*)?',
        term: 'get started'
      }
    ]
  },
  resources: [
    {
      href: 'https://www.adobe.com/go/target_r_release_notes',
      label: Granite.I18n[locale]['What\'s New With Adobe Target']
    },
    {
      href: 'https://www.adobe.com/go/target_product_home',
      label: Granite.I18n[locale]['Help Home']
    },
    {
      href: 'https://www.adobe.com/go/target_contact-support',
      label: Granite.I18n[locale]['Customer Care']
    },
    {
      href: 'https://www.adobe.com/go/target_personalization',
      label: Granite.I18n[locale]['Blogs']
    },
    {
      href: 'https://www.youtube.com/channel/UC75Ir2u14wz-0IKWH-RkWAA',
      label: Granite.I18n[locale]['Videos']
    },
    {
      href: 'https://developers.adobetarget.com/',
      label: Granite.I18n[locale]['Developer Connection']
    },
    {
      href: 'https://www.adobe.com/go/target_status_standardpremium',
      label: Granite.I18n[locale]['System Status']
    }
  ]
});

export default helpConfigOverride;
